import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * a custom operator to clone an array, this is a shallow copy.
 */
export function cloneImmutableArray<T = any[]>() {
  return (source$: Observable<T[]>): Observable<T[]> => {
    return source$.pipe(map((sourceArray: T[]) => [...sourceArray]));
  };
}
